import moment from "moment";
class attributes {
  constructor(
    operId,
    levelId,
    mgrOperId,
    suplenteOperId,
    from,
    to,
    name,
    manager,
    sustitute,
    levelName,
    level
  ) {
    this.operId = operId;
    this.levelId = levelId;
    this.mgrOperId = mgrOperId;
    this.suplenteOperId = suplenteOperId;
    this.from = from == null ? " " : moment.utc(from).format("DD-MM-YYYY");
    this.to = to == null ? " " : moment.utc(to).format("DD-MM-YYYY");
    this.name = name;
    this.manager = manager;
    this.sustitute = sustitute;
    this.levelName = levelName;
    this.level = level;
  }
  static fromJson({
    operId,
    nivelId,
    mgrOperId,
    suplenteOperId,
    fecDesde,
    fecHasta,
    nomOper,
    manager,
    suplente,
    nombreNivel,
    nivel,
  }) {
    return new attributes(
      operId,
      nivelId,
      mgrOperId,
      suplenteOperId,
      fecDesde,
      fecHasta,
      nomOper,
      manager,
      suplente,
      nombreNivel,
      nivel
    );
  }
}
export default attributes;
